// src/app/modules/ThreatAlerts/database/column-formatters/AlertTypeColumnFormatter.jsx
import React from "react";

const TYPE_CONFIG = {
  blacklisted_visitor:    { label: 'Blacklisted Visitor', pill: 'sety-pill-red' },
  high_risk_visitor:      { label: 'High Risk Visitor',   pill: 'sety-pill-amber' },
  suspicious_pattern:     { label: 'Suspicious Pattern',  pill: 'sety-pill-purple' },
  network_threat:         { label: 'Network Threat',      pill: 'sety-pill-purple' },
  rapid_visits:           { label: 'Rapid Visits',        pill: 'sety-pill-amber' },
  name_mismatch:          { label: 'Name Mismatch',       pill: 'sety-pill-purple' },
  banned_person_detected: { label: 'Banned Person',       pill: 'sety-pill-red' },
};

export function AlertTypeColumnFormatter(cellContent, row) {
  const cfg = TYPE_CONFIG[row.alert_type] || { label: row.alert_type, pill: 'sety-pill-grey' };
  return <span className={`sety-pill ${cfg.pill}`}>{cfg.label}</span>;
}
